{
	"imprintTitle": "Otisk",
	"termsAndConditionsTitle": "Smluvní podmínky",
	"privacyPolicyTitle": "Zásady ochrany osobních údajů",
	"openSourceAttributionTitle": "Open Source Atribuce"
}
